export const unsupportedRuntimeError = new NotImplementedError("Unsupported runtime");
//# sourceMappingURL=base.js.map